







import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import TokenService from '@/helpers/token';
import i18n from '@/plugins/i18n';
import bus from '@/helpers/bus';

@Component({})
export default class App extends Vue {
  get walletConnected() {
    return this.$store.state.walletConnected;
  }

  @Watch('walletConnected', { deep: true })
  onWalletConnectedChanged() {
    localStorage.setItem('walletConnected', JSON.stringify(this.walletConnected));
  }

  async mounted() {
    await this.getCountryCodeInfo();
    await this.getListTokenPriceSellNft();
  }



  async getListItem() {
    await this.$store.dispatch('home/getListItem');
  }

  async getListTokenPriceSellNft() {
    await this.$store.dispatch('home/getListTokenPriceSellNft')
  }


  async getCountryCodeInfo() {
    const lang = TokenService.getLang() || 'en';
    this.$store.dispatch('setLanguage', lang);
    TokenService.setLang(lang);
    i18n.locale = lang;

  };
}
